import { useQuery } from "@tanstack/react-query";
import { Tooltip, Typography, Stack } from "@altimateai/lego";
import { IconInfoCircle } from "@tabler/icons-react";
import dayjs from "dayjs";
import { getLastFetchedTime } from "@/helpers/apis";
import { GET_LAST_UPDATED_TIME } from "../constants";
import { GroupsDateRange } from "@/pages/query/groups/index";

const GroupsHeader = () => {
  const { data: infoTimeString, isFetching: isLoading } = useQuery({
    queryKey: [GET_LAST_UPDATED_TIME],
    queryFn: getLastFetchedTime,
  });

  const getLastUpdatedTooltip = () => {
    if (!infoTimeString?.time_string) return null;
    const formattedTime = dayjs
      .utc(`1970-01-01T${infoTimeString.time_string}Z`, "HH:mm:ss")
      .local()
      .format("HH:mm:ss A");

    return (
      <div>
        <p>Queries with execution time {">"}10 secs are shown.</p>
        <p>
          The data was last updated at <strong>{formattedTime} UTC</strong>
        </p>
      </div>
    );
  };

  return (
    <div className="al-bg-white al-p-3 al-rounded-t-md">
      <Stack align={"center"} justify={"between"}>
        <Stack align="center">
          <Typography variant="h4">Queries</Typography>
          {!isLoading && infoTimeString && (
            <Tooltip title={getLastUpdatedTooltip()}>
              <div className="al-cursor-help al-text-gray-500 hover:al-text-gray-700 al-p-2">
                <IconInfoCircle size={18} />
              </div>
            </Tooltip>
          )}
        </Stack>
        <Stack direction="row" justify="between" align="center" gap="md">
          <Stack direction="row" align="center" gap="md">
            <GroupsDateRange />
            <div id="filter-container" />
          </Stack>
          <Stack align="center" gap="md">
            <div id="saved-filters-container" />
          </Stack>
        </Stack>
      </Stack>
      <Typography variant="body" size="xxs" className="al-text-gray-500">
        This page shows parameterized query groups based on query patterns.
      </Typography>
    </div>
  );
};

export default GroupsHeader;
